<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Permission" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-permission-form [permission]="permission" *ngIf="permission"></app-permission-form>
        </form>
      </div>
    </section>
  </div>
</div>
